module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card admin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Список компаний\n            "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    class: {
      active: _vm.showFilter
    },
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFilter = !_vm.showFilter
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Фильтр\n                ")]), _vm._v(" "), (_vm.currentUser.hasPermission('company.add')) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Добавить компанию\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.showFilter) ? _c('div', {
    staticClass: "mt-3 mt-lg-1"
  }, [_c('div', {
    staticClass: "row col-6"
  }, [_c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.query),
      expression: "params.query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.params.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "query", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-block admin__list"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем компании..."
    }
  }) : _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-1 d-none d-md-block"
    }, [_vm._v("\n                    " + _vm._s(item.id) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2"
    }, [_vm._v("\n                   " + _vm._s(item.name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-3 col-lg-2"
    }, _vm._l((item.users), function(user, index) {
      return _c('span', {
        staticClass: "badge badge-info"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'ViewProfile',
            params: {
              id: user.id
            }
          }
        }
      }, [_vm._v(_vm._s(user.fullname))])], 1)
    })), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2"
    }, [(item.enabled) ? _c('span', [_vm._v("Да")]) : _c('span', [_vm._v("Нет")])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2"
    }, [_vm._v("\n                    " + _vm._s(item.sort) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2 col-lg-3"
    }, [(_vm.currentUser.hasPermission('company.update')) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Изменить\n                    ")]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.itemsPage.paginator.total_count,
      "per-page": _vm.itemsPage.paginator.limit
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.$set(_vm.params, "page", $$v)
      },
      expression: "params.page"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-1 small text-muted"
  }, [_c('div', {
    staticClass: "col-1 d-none d-md-block"
  }, [_vm._v("Id")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3 col-lg-2"
  }, [_vm._v("Руководители")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Включена")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Сортировка")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-3"
  }, [_vm._v("Управление")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ec6e42c0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-ec6e42c0"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Admin/Companies.vue
// module id = 1079
// module chunks = 1